import { render, staticRenderFns } from "./concrete.vue?vue&type=template&id=0b8e8e28&scoped=true"
import script from "./concrete.vue?vue&type=script&lang=js"
export * from "./concrete.vue?vue&type=script&lang=js"
import style0 from "./concrete.vue?vue&type=style&index=0&id=0b8e8e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e8e28",
  null
  
)

export default component.exports